import { render, staticRenderFns } from "./CrewStatement.vue?vue&type=template&id=596c810a&scoped=true&"
import script from "./CrewStatement.vue?vue&type=script&lang=js&"
export * from "./CrewStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c810a",
  null
  
)

export default component.exports